"use strict";

import { invariant } from '@autoguru/utilities';
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const contactNumbersContext = /*#__PURE__*/createContext(null);
export const useContactNumbers = () => {
  const contextValue = useContext(contactNumbersContext);
  !(contextValue !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Please have a  <ContactNumbersProvilder /> set in your tree') : invariant(false) : void 0;
  return contextValue;
};
export const ContactNumbersProvider = ({
  children
}) => {
  const contactNumbersContextValue = useMemo(() => ({
    successContactNumber: '07 5612 5347',
    ordersContactNumber: '02 5300 2825',
    agCustomerContactNumber: '1300 655 661',
    wexContactNumber: '1300 319 886',
    ampolContactNumber: '1300 656 014',
    smsFromNumberForTransactional: '0480 018 336'
  }), []);
  return /*#__PURE__*/_jsx(contactNumbersContext.Provider, {
    value: contactNumbersContextValue,
    children: children
  });
};